<template>
  <form method="post" :action="action" class="text-left my-4 live-form">
    <div class="row mb-4 text-sm">
      <div class="col-12 col-md-6">
        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Policyholder Name</label>
              <div class="form-control-wrap">
                {{ placement.policyholder.name ? placement.policyholder.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Public Adjuster</label>
              <div class="form-control-wrap">
                {{ adjusters.public_adjuster && adjusters.public_adjuster.contact_data ? adjusters.public_adjuster.contact_data.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-5">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Public Adjuster Company</label>
              <div class="form-control-wrap">
                {{ adjusters.public_adjuster && adjusters.public_adjuster.company_data ? adjusters.public_adjuster.company_data.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-4">
          <div class="col">
            <div class="form-group">
              <span class="form-control-wrap font-weight-bold">
                Rent
                <i
                  class="recalculate-mmf fa fa-sync px-3"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Recalculate rent and management fees"
                  style="cursor: pointer;"
                  @click="recalculateMmf"
                ></i>
              </span>
              <template v-if="temp.rents.length">
                <input type="hidden" name="budget[pro_rated_start_date]" :value="budget.pro_rated_start_date" />
                <input type="hidden" name="budget[pro_rated_end_date]" :value="budget.pro_rated_end_date" />

                <input type="hidden" name="budget[next_month_start_date]" :value="budget.next_month_start_date" />
                <input type="hidden" name="budget[next_month_end_date]" :value="budget.next_month_end_date" />
              </template>
              <div class="form-control-wrap justify-content-between ml-3" v-for="(item, index) in temp.rents" :key="index">
                <div class="row align-items-center">
                  <div class="col-10 col-md-9 d-flex flex-wrap flex-md-nowrap align-items-center">
                    <strong class="text-nowrap pr-2">{{ item.name }}:</strong>
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="form-control-wrap form-datepicker">
                          <v-datepicker
                            type="text"
                            autocomplete="off"
                            class="form-control datepicker text-center"
                            pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\\d\\d"
                            v-model="item.start_date"
                            :name="`rent_items[${index}][start_date]`"
                            :disabled="has_completed_initial_invoice"
                            @input="calculateProrationAmount(item.start_date, item.end_date, index)"
                          >
                          </v-datepicker>
                        </div>
                      </div>
                      <span class="px-2"> - </span>
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="form-control-wrap form-datepicker">
                          <v-datepicker
                            type="text"
                            autocomplete="off"
                            class="form-control datepicker text-center"
                            pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\\d\\d"
                            v-model="item.end_date"
                            :name="`rent_items[${index}][end_date]`"
                            :disabled="has_completed_initial_invoice"
                            @input="calculateProrationAmount(item.start_date, item.end_date, index)"
                          >
                          </v-datepicker>
                        </div>
                      </div>
                    </div>
                    <strong class="text-nowrap px-1">({{ calculateDays(item.start_date, item.end_date) }})</strong>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="form-control-wrap form-control-currency">
                      <i class="fas fa-dollar-sign"></i>
                      <input type="hidden" :name="`rent_items[${index}][name]`" :value="item.name" />
                      <input type="hidden" :name="`rent_items[${index}][type]`" value="rent" />
                      <v-currency
                        :is-blank="false"
                        type="text"
                        class="form-control text-right"
                        v-model="item.amount"
                        :name="`rent_items[${index}][amount]`"
                        :disabled="has_completed_initial_invoice"
                      ></v-currency>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="hasFees" class="form-row mb-4">
          <div class="col-12">
            <span class="form-control-wrap font-weight-bold">Fees & Deposits</span>
          </div>
          <div class="col-12">
            <div v-show="feesAndDeposits.cleaning_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>Lease Cleaning Fee</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[cleaning_fee]"
                    v-model="budget.cleaning_fee"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="feesAndDeposits.application_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>Lease App Fee</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[application_fee]"
                    v-model="budget.application_fee"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="feesAndDeposits.pet_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>Lease Pet Fee</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[pet_fee]"
                    v-model="budget.pet_fee"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="feesAndDeposits.misc_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>Misc Fees</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[misc_fee]"
                    v-model="budget.misc_fee"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="feesAndDeposits.furniture_cleaning_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>Furniture Cleaning Fee</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[furniture_cleaning_fee]"
                    v-model="budget.furniture_cleaning_fee"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="feesAndDeposits.furniture_delivery_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>Furniture Delivery Fee</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[furniture_delivery_fee]"
                    v-model="budget.furniture_delivery_fee"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="feesAndDeposits.one_time_admin_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>One Time Admin Fee</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[one_time_tps_fee]"
                    v-model="budget.one_time_tps_fee"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="feesAndDeposits.one_time_management_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>One Time Management Fee</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[one_time_fee]"
                    v-model="budget.one_time_fee"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="hasDeposits" class="form-row mb-4">
          <div class="col-12">
            <span class="form-control-wrap font-weight-bold">Deposits</span>
          </div>
          <div class="col-12">
            <div v-show="deposits.landlord > 0" class="row ml-1 align-items-start justify-content-between">
              <div class="col-auto">
                <strong>Landlord Security Deposit</strong>
                <p class="m-0 ml-3">
                  Paid out of <mark>{{ getPaidOutof(budget.landlord_paid_out_of) }}</mark>
                </p>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[landlord_deposit]"
                    v-model="budget.landlord_deposit"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="deposits.pet > 0" class="row ml-1 align-items-start justify-content-between">
              <div class="col-auto">
                <strong>Pet Security Deposit</strong>
                <p class="m-0 ml-3">
                  Paid out of <mark>{{ getPaidOutof(budget.pet_paid_out_of) }}</mark>
                </p>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[pet_deposit]"
                    v-model="budget.pet_deposit"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="deposits.furniture > 0" class="row ml-1 align-items-start justify-content-between">
              <div class="col-auto">
                <strong>Furniture Security Deposit</strong>
                <p class="m-0 ml-3">
                  Paid out of <mark>{{ getPaidOutof(budget.furniture_paid_out_of) }}</mark>
                </p>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[furniture_deposit]"
                    v-model="budget.furniture_deposit"
                    :disabled="has_completed_initial_invoice"
                  ></v-currency>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="managementFee > 0 && monthlyManagementFees.length">
          <div class="form-row" v-for="(period, index) in temp.management_fees" :key="index">
            <div class="col-12">
              <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                  <strong>{{ period.name }} {{ mfPercentage }}</strong>
                </div>
                <div class="col-4">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <input type="hidden" :name="`mmf_items[${index}][name]`" :value="period.name" />
                    <input type="hidden" :name="`mmf_items[${index}][start_date]`" :value="period.start_date" />
                    <input type="hidden" :name="`mmf_items[${index}][end_date]`" :value="period.end_date" />
                    <input type="hidden" :name="`mmf_items[${index}][type]`" value="management_fee" />
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      :name="`mmf_items[${index}][amount]`"
                      v-model="period.amount"
                      :disabled="has_completed_initial_invoice"
                    ></v-currency>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Insurance Company</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.company_data && adjusters.carrier_adjuster.company_data.name
                    ? adjusters.carrier_adjuster.company_data.name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Carrier Adjuster</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.contact_data && adjusters.carrier_adjuster.contact_data.name
                    ? adjusters.carrier_adjuster.contact_data.name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Adjuster Preferences</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster &&
                  adjusters.carrier_adjuster.contact_data &&
                  adjusters.carrier_adjuster.contact_data.invoicing_preferences
                    ? adjusters.carrier_adjuster.contact_data.invoicing_preferences
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Personal Negotiated Fees</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.contact_data && adjusters.carrier_adjuster.contact_data.negotiated_fees
                    ? adjusters.carrier_adjuster.contact_data.negotiated_fees
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Company Negotiated Fees</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.company_data && adjusters.carrier_adjuster.company_data.negotiated_fees
                    ? adjusters.carrier_adjuster.company_data.negotiated_fees
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Company Guidelines</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.company_data && adjusters.carrier_adjuster.company_data.guidelines
                    ? adjusters.carrier_adjuster.company_data.guidelines
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Fees Paid out of</label>
              <div class="form-control-wrap">
                {{ housing_fee_type }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Pays Electronically</label>
              <div class="form-control-wrap">
                {{ pays_directly }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Carrier will pay TPS Housing direct</label>
              <div class="form-control-wrap">
                {{ pays_electronically }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <p class="border-bottom">
          <strong>Invoice Total:</strong>
          <span class="float-right">${{ formatMoney(totalAmount) }}</span>
        </p>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: ["placement", "adjusters", "budget", "property", "hotel", "has_completed_initial_invoice", "temp"],
  data() {
    return {
      refreshMmf: 0,
      forceUpdate: { rent: false, management_fee: false }
    };
  },
  watch: {
    monthlyManagementFees: {
      handler() {
        this.temp.management_fees = this.getReactiveFees("monthlyManagementFees", "management_fee");
      },
      immediate: true
    },
    rentItems: {
      handler() {
        this.temp.rents = this.getReactiveFees("rentItems", "rent");
      },
      immediate: true
    }
  },
  methods: {
    getReactiveFees(key, type) {
      if (!this.forceUpdate[type] && this.budget && this.budget.line_items && this.budget.line_items.length) {
        this.forceUpdate[type] = false;

        return this[key].map(item => {
          const lineItem = this.budget.line_items.find(i => i.name === item.name && i.type === type);

          return {
            ...item,
            amount: lineItem ? this.realFloat(lineItem.amount) : 0
          };
        });
      }

      return this[key].map(period => ({ ...period }));
    },
    recalculateMmf() {
      if (!this.temp.rents.length) return;

      this.temp.rents.forEach((item, index) => this.calculateProrationAmount(item.start_date, item.end_date, index));
      $('[name="rent_items[0][amount]"]').trigger("change");
    },
    calculateDays(start_date, end_date) {
      try {
        const start = moment(start_date, "MM/DD/YYYY");
        const end = moment(end_date, "MM/DD/YYYY");
        const days = end.diff(start, "days") + 1;
        return isNaN(days) ? "0 days" : days + (days === 1 ? " day" : " days");
      } catch (error) {
        return "0 days";
      }
    },
    calculateMarkup(budget_markup) {
      let amount = 0;

      if (!budget_markup) return amount;

      switch (budget_markup.budget_markup_type_id) {
        case "1":
        case 1:
          amount = this.realFloat(budget_markup.amount);
          break;
        case "2":
        case 2:
          const markup_amount = this.realFloat(budget_markup.amount) / 100;
          amount = this.realFloat(this.leaseAndFhaRate * markup_amount);
          break;
        default:
          break;
      }

      return amount;
    },
    calculateProrationAmount(start_date, end_date, index = null) {
      const periods = window.findPeriods(start_date, end_date);
      const amount = this.calculateRentAmount(periods);
      const rentAmount = this.formatMoney(amount, true);
      this.temp.rents[index].amount = rentAmount;
      this.forceUpdate.management_fee = true;
      this.refreshMmf++;

      if (index === 0) {
        this.budget.pro_rated_start_date = start_date;
        this.budget.pro_rated_end_date = end_date;
      } else if (index === 1) {
        this.budget.next_month_start_date = start_date;
        this.budget.next_month_end_date = end_date;
      }
    },
    calculateRentAmount(periods) {
      let amount = 0;

      periods.forEach(period => {
        let diffDays = window.diffDays(period.start_date, period.end_date, this.isCorporate);
        amount += (this.leaseAndFhaRate / 30) * diffDays;
      });

      return amount;
    },
    realFloat(val) {
      return window.realFloat(val);
    },
    formatMoney(amount) {
      return window.formatMoney(amount);
    },
    getPaidOutof(id) {
      const paidOutof = app.options.paid_out_of.find(opt => opt.id == id);
      return paidOutof ? paidOutof.text : "-";
    }
  },
  computed: {
    action() {
      return `/api/invoice_action?property_id=${this.budget.id}`;
    },
    isCorporate() {
      return this.property && this.property.lease_detail && this.property.lease_detail.lease_rate_type === "Daily";
    },
    housing_fee_type() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const housing_fee_type = app.options.housing_fee_types.find(i => i.id == this.adjusters.carrier_adjuster.company_data.housing_fee_type_id);
        return housing_fee_type ? housing_fee_type.text : "-";
      }

      return "-";
    },
    pays_directly() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const pays_directly = app.options.confirm_extra.find(i => i.id == this.adjusters.carrier_adjuster.company_data.pays_directly);
        return pays_directly ? pays_directly.text : "-";
      }

      return "-";
    },
    pays_electronically() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const pays_electronically = app.options.confirm_extra.find(i => i.id == this.adjusters.carrier_adjuster.company_data.pays_electronically);
        return pays_electronically ? pays_electronically.text : "-";
      }

      return "-";
    },
    feesAndDeposits() {
      const feesAndDeposits = {
        cleaning_fee: this.budget.cleaning_fee_first_payment ? this.realFloat(this.budget.cleaning_fee) : 0,
        application_fee: this.budget.application_fee_first_payment ? this.realFloat(this.budget.application_fee) : 0,
        pet_fee: this.budget.pet_fee_first_payment ? this.realFloat(this.budget.pet_fee) : 0,
        misc_fee: this.budget.misc_fee_first_payment ? this.realFloat(this.budget.misc_fee) : 0,
        furniture_cleaning_fee: this.budget.furniture_cleaning_fee ? this.realFloat(this.budget.furniture_cleaning_fee) : 0,
        furniture_delivery_fee: this.budget.furniture_delivery_fee ? this.realFloat(this.budget.furniture_delivery_fee) : 0,
        one_time_management_fee: this.budget.one_time ? this.realFloat(this.budget.one_time_fee) : 0,
        one_time_admin_fee: this.budget.one_time_tps ? this.realFloat(this.budget.one_time_tps_fee) : 0
      };

      return feesAndDeposits;
    },
    hasFees() {
      const keys = Object.keys(this.feesAndDeposits);
      return keys.some(key => this.feesAndDeposits[key] > 0);
    },
    deposits() {
      return {
        landlord:
          this.budget.landlord_paidby_id != 1 && this.budget.landlord_deposit_first_payment ? this.realFloat(this.budget.landlord_deposit) : 0,
        pet: this.budget.pet_paidby_id != 1 && this.budget.pet_deposit_first_payment ? this.realFloat(this.budget.pet_deposit) : 0,
        furniture: this.budget.furniture_paidby_id != 1 && this.budget.furniture_deposit_enable ? this.realFloat(this.budget.furniture_deposit) : 0
      };
    },
    hasDeposits() {
      return this.deposits.landlord || this.deposits.pet || this.deposits.furniture;
    },
    leaseAndFhaRate() {
      return this.realFloat(this.budget.unfurnished_rent) + this.realFloat(this.budget.fha_package);
    },
    unfurnishedRent() {
      return this.realFloat(this.budget.unfurnished_rent);
    },
    itemsTotal() {
      let total = 0;

      let keys = [
        "cleaning_fee",
        "pet_fee",
        "application_fee",
        "misc_fee",
        "landlord_deposit",
        "pet_deposit",
        "furniture_deposit",
        "furniture_cleaning_fee",
        "furniture_delivery_fee",
        "one_time_fee",
        "one_time_tps_fee"
      ];

      for (let key of keys) {
        switch (key) {
          case "cleaning_fee":
          case "pet_fee":
          case "application_fee":
          case "misc_fee":
            if (this.budget[key + "_first_payment"]) total += this.realFloat(this.budget[key]);
            break;
          case "landlord_deposit":
            if (this.budget.landlord_paidby_id != 1 && this.budget[key + "_first_payment"]) total += this.realFloat(this.budget[key]);
            break;
          case "pet_deposit":
            if (this.budget.pet_paidby_id != 1 && this.budget[key + "_first_payment"]) total += this.realFloat(this.budget[key]);
            break;
          case "furniture_deposit":
            if (this.budget.furniture_paidby_id != 1 && this.budget.furniture_deposit_enable) total += this.realFloat(this.budget[key]);
            break;
          case "one_time_fee":
            if (this.budget.one_time) total += this.realFloat(this.budget[key]);
            break;
          case "one_time_tps_fee":
            if (this.budget.one_time_tps) total += this.realFloat(this.budget[key]);
            break;
          default:
            total += this.realFloat(this.budget[key]);
            break;
        }
      }

      const rents = this.temp.rents ? this.temp.rents.reduce((total, rent) => total + this.realFloat(rent.amount), 0) : 0;

      return total + rents;
    },
    totalAmount() {
      const managementFees =
        this.temp && this.temp.management_fees ? this.temp.management_fees.reduce((total, period) => total + this.realFloat(period.amount), 0) : 0;
      return this.realFloat(this.itemsTotal) + managementFees;
    },
    markup() {
      const [markup] = this.budget.budget_markups ? this.budget.budget_markups : [];
      return markup;
    },
    managementFee() {
      if (!this.markup) return 0;
      if (this.markup.budget_frequency_type === "Daily") return this.calculateMarkup(this.markup) * 30;

      return this.calculateMarkup(this.markup);
    },
    mfPercentage() {
      return this.markup && this.markup.budget_markup_type_id == 2 ? `(${this.realFloat(this.markup.amount)}%)` : "";
    },
    monthlyManagementFees() {
      this.refreshMmf;
      return this.temp.rents
        .reduce((managementFees, rent) => {
          const proRated = window.findMonthPeriods(rent.start_date, rent.end_date, this.managementFee, this.isCorporate);
          return [...managementFees, ...proRated];
        }, [])
        .reduce((managementFees, rent) => {
          const existing = managementFees.find(item => item.name === rent.name);
          if (existing) {
            existing.amount += rent.amount;
          } else {
            managementFees.push(rent);
          }

          return managementFees;
        }, [])
        .map(period => ({ ...period, type: "management_fee", name: `${period.name} Management Fee` }));
    },
    rentItems() {
      const pro_rated_periods = window.findPeriods(this.budget.pro_rated_start_date, this.budget.pro_rated_end_date);
      const next_month_periods = window.findPeriods(this.budget.next_month_start_date, this.budget.next_month_end_date);

      const items = [
        {
          name: "Pro-rated Rent",
          start_date: this.budget.pro_rated_start_date,
          end_date: this.budget.pro_rated_end_date,
          type: "rent",
          amount: this.calculateRentAmount(pro_rated_periods, true)
        },
        {
          name: "Next Month Rent",
          start_date: this.budget.next_month_start_date,
          end_date: this.budget.next_month_end_date,
          type: "rent",
          amount: this.calculateRentAmount(next_month_periods, true)
        }
      ];

      return items;
    }
  },
  mounted() {
    $(".recalculate-mmf").tooltip("enable");
  }
};
</script>

<style>
.swal2-content {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/placement/invoice-request.vue